import { registerComponent } from '@gig/magic-common';
import RoundProgressBarComponent from './round-progress-bar.vue.js';

var RoundProgressBar = registerComponent(RoundProgressBarComponent);

export { RoundProgressBar };
